import * as types from "../types/overview";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  fetchAllResponses,
  fetchAllClients,
  fetchAllSales,
  fetchAllDeliveries,
  fetchAllRevenue,
  fetchAllYears,
  fetchActiveGoal,
  createNewGoal,
  deleteExistingGoal,
  updateExistingGoal,
} from "../../networking/overview/networking";

function* fetchResponseData(action) {
  try {
    if (action.payload) {
      const responses = yield call(fetchAllResponses, action.payload);
      if (responses.error === null) {
        yield put({
          type: types.SET_RESPONSE_DATA,
          content: responses.payload,
        });
      } else {
        throw new Error({ error: "Kunne ikke hente responser." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente responser." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_RESPONSE_DATA, message: error });
  }
}

function* fetchSalesData(action) {
  try {
    if (action.payload) {
      const sales = yield call(fetchAllSales, action.payload);
      if (sales.error === null) {
        yield put({ type: types.SET_SALES_DATA, content: sales.payload });
      } else {
        throw new Error({ error: "Kunne ikke hente salg." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente salg." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_SALES_DATA, message: error });
  }
}

function* fetchClientsData(action) {
  try {
    if (action.payload) {
      const clients = yield call(fetchAllClients, action.payload);
      if (clients.error === null) {
        yield put({ type: types.SET_CLIENTS_DATA, content: clients.payload });
      } else {
        throw new Error({ error: "Kunne ikke hente salg." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente salg." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_CLIENTS_DATA, message: error });
  }
}

function* fetchDeliveriesData(action) {
  try {
    if (action.payload) {
      const clients = yield call(fetchAllDeliveries, action.payload);
      if (clients.error === null) {
        yield put({
          type: types.SET_DELIVERIES_DATA,
          content: clients.payload,
        });
      } else {
        throw new Error({ error: "Kunne ikke hente salg." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente salg." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_DELIVERIES_DATA, message: error });
  }
}

function* fetchRevenueData(action) {
  try {
    if (action.payload) {
      const revenue = yield call(fetchAllRevenue, action.payload);
      if (revenue.error === null) {
        yield put({ type: types.SET_REVENUE_DATA, content: revenue.payload });
      } else {
        throw new Error({ error: "Kunne ikke hente salg." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente inntekter." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_REVENUE_DATA, message: error });
  }
}

function* fetchRegistrationYears(action) {
  try {
    if (action.payload) {
      const details = yield call(fetchAllYears, action.payload);
      if (details.error === null) {
        yield put({
          type: types.SET_SELECTION_YEARS,
          content: details.payload,
        });
      } else {
        throw new Error({ error: "Kunne ikke hente salg." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente inntekter." });
    }
  } catch ({ error }) {
    yield put({ type: types.RESET_SELECTION_YEARS, message: error });
  }
}

function* fetchGoalData(action) {
  try {
    if (action.payload) {
      const details = yield call(fetchActiveGoal, action.payload);
      if (details.error === null) {
        yield put({ type: types.SET_GOAL_DATA, progress: details.payload });
      } else {
        throw new Error({ error: "Kunne ikke hente mål." });
      }
    } else {
      throw new Error({ error: "Kunne ikke hente mål." });
    }
  } catch ({ error }) {
    yield put({ type: types.REVOKE_GOAL_DATA });
  }
}

function* performCreateNewGoal(action) {
  try {
    if (action.payload) {
      var response = yield call(createNewGoal, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_CREATE_NEW_GOAL });
        yield put({
          type: types.CHANGE_OVERVIEW_MODALS,
          modal: { addGoalModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere kunde.");
      }
    }
  } catch (e) {
    yield put({ type: types.RESET_CREATE_NEW_GOAL, message: e });
  }
}

function* performDeleteGoal(action) {
  try {
    if (action.payload) {
      var response = yield call(deleteExistingGoal, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_SINGLE_GOAL });
        yield put({
          type: types.CHANGE_OVERVIEW_MODALS,
          modal: { editGoalModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette mål.");
      }
    }
  } catch (e) {
    yield put({ type: types.RESET_DELETE_SINGLE_GOAL, message: e });
  }
}

function* performUpdateGoal(action) {
  try {
    if (action.payload) {
      var response = yield call(updateExistingGoal, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_SINGLE_GOAL });
        yield put({
          type: types.CHANGE_OVERVIEW_MODALS,
          modal: { editGoalModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere mål.");
      }
    }
  } catch (e) {
    yield put({ type: types.RESET_UPDATE_SINGLE_GOAL, message: e });
  }
}

function* overviewSaga() {
  yield all([
    takeEvery(types.REQUEST_RESPONSE_DATA, fetchResponseData),
    takeEvery(types.REQUEST_SALES_DATA, fetchSalesData),
    takeEvery(types.REQUEST_CLIENTS_DATA, fetchClientsData),
    takeEvery(types.REQUEST_DELIVERIES_DATA, fetchDeliveriesData),
    takeEvery(types.REQUEST_REVENUE_DATA, fetchRevenueData),
    takeEvery(types.REQUEST_SELECTION_YEARS, fetchRegistrationYears),
    takeEvery(types.REQUEST_GOAL_DATA, fetchGoalData),
    takeEvery(types.REQUEST_CREATE_NEW_GOAL, performCreateNewGoal),
    takeEvery(types.REQUEST_DELETE_SINGLE_GOAL, performDeleteGoal),
    takeEvery(types.REQUEST_UPDATE_SINGLE_GOAL, performUpdateGoal),
  ]);
}

export default overviewSaga;
